import { TIER } from "@/components/ExperiencePage/ProgramDetailsSection/housing/constants.js";

export const useTier = (tierName) => {
  return TIER[tierName || "Tier I"];
};
